import React, {useState, useEffect, useRef} from 'react';
import { 
    Flex, HStack, VStack, Text, Button, IconButton, Divider, Link
} from '@chakra-ui/react';
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { MdAccountBox, MdRadar, MdSmartDisplay, MdFeaturedPlayList, MdClose, MdOutlineStackedLineChart } from 'react-icons/md';
import { FaUser, FaTelegramPlane, FaDiscord, FaTelegram, FaHandshake, FaWallet, FaSignOutAlt, FaBars, FaSearchengin, FaCog } from 'react-icons/fa';
import { PiChartLineUpFill, PiEye } from 'react-icons/pi';
import { ImRoad } from 'react-icons/im';
import { BsTwitterX } from 'react-icons/bs';
import { FaRegStar } from 'react-icons/fa';
import "../../styles/index.scss";
import { confirmChoiceAlert } from "../../utils/confirmChoice";
import { TRADINGVIEW_CONFIGS_SUB_PATH, TRADINGVIEW_TRANSACTIONS_SUB_PATH } from "../../constants2";

function LeftPanel({ }) {
    const locations = useLocation();
    const navigate = useNavigate();
    const [ isShowLeftPanel, setIsShowLeftPanel ] = useState(false);
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);

    const handleLogout = () => {
        confirmChoiceAlert(() => {
            removeCookie("loginCookie");
        });
    }

    return (
        <Flex flexDirection="column">
            <Flex justify="flex-start" position="fixed" left={0} top={0} display={{ base: isShowLeftPanel ? "none" : "inherit", md: "none", lg: "none" }}>
                <IconButton variant="ghost" _hover="transparent" color="white" icon={<FaBars />} 
                    onClick={() => {
                        setIsShowLeftPanel(!isShowLeftPanel)
                    }}
                />
            </Flex>
           
            <Flex flexDirection="column" w="180px" h="100vh" px={2} py={4} justify="space-between"
                borderWidth={1} borderColor="gray.700" display={{ base: (isShowLeftPanel ? "inherit" : "none"), md: "inherit", lg: "inherit" }}
            >   
                <VStack>
                    <HStack>
                        <Text fontSize="12px" color="white"className='one-font'>ONE TOKEN</Text>
                        <IconButton variant="ghost" _hover="transparent" color="white" icon={<MdClose />} 
                            display={{ base: (isShowLeftPanel ? "inherit" : "none"), md: "none", lg: "none" }}
                            onClick={() => {
                                setIsShowLeftPanel(!isShowLeftPanel)
                            }}
                        />
                    </HStack>

                    <Flex flexDirection="column" mt={2}>
                        <Text fontSize="12px" color="gray.400">Trading View</Text>
                        <Button variant="ghost" height={8} color='white'_hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                            className={(locations.pathname === "/") || (locations.pathname === TRADINGVIEW_TRANSACTIONS_SUB_PATH) ? 'highlight-button' : ''} 
                            onClick={() => navigate(TRADINGVIEW_TRANSACTIONS_SUB_PATH)}
                        >
                            <MdFeaturedPlayList /> <Text fontSize="11px">Transactions</Text>
                        </Button>
                        <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === TRADINGVIEW_CONFIGS_SUB_PATH ? 'highlight-button' : ''} 
                            onClick={() => navigate(TRADINGVIEW_CONFIGS_SUB_PATH)}
                        >
                            <FaCog /> <Text fontSize="11px">Configs</Text>
                        </Button>
                    </Flex>
                </VStack>
         
                {/* <Flex flexDirection="column" mt={2}>
                    <Text fontSize="12px" color="gray.400">ONE radar</Text>
                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                        className={(locations.pathname === "/" && !locations.search) ? 'highlight-button' : ''} onClick={() => navigate("/")}
                    >
                        <MdRadar /> <Text fontSize="11px">Alpha picks</Text>
                    </Button>

                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                        className={(locations.pathname === "/" && locations.search === "?follow_tickers=true") ? 'highlight-button' : ''} 
                        onClick={() => navigate("/?follow_tickers=true")}
                    >
                        <FaRegStar /> <Text fontSize="11px">Follow Tickers</Text>
                    </Button>
                </Flex> */}

                {/* <Flex flexDirection="column" mt={2}>
                    <Text fontSize="12px" color="gray.400">Tracking</Text>
                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                        className={locations.pathname === "/analysic-tickers" && !locations.search? 'highlight-button' : ''} onClick={() => navigate("/analysic-tickers")}
                    >
                        <FaSearchengin /> <Text fontSize="11px">Analysic Tickers</Text>
                    </Button>

                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                        className={(locations.pathname === "/analysic-tickers" && locations.search === "?follow_analysic_tickers=true") ? 'highlight-button' : ''} 
                        onClick={() => navigate("/analysic-tickers?follow_analysic_tickers=true")}
                    >
                        <FaRegStar /> <Text fontSize="11px">Follow Tickers</Text>
                    </Button>
                </Flex>


                <Flex flexDirection="column" mt={2}>
                    <Text fontSize="12px" color="gray.400">Dashboard</Text>
                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                        className={locations.pathname === "/strategy-trading" ? 'highlight-button' : ''} onClick={() => navigate("/strategy-trading")}
                    >
                        <PiChartLineUpFill /> <Text fontSize="11px">Strategy Trading</Text>
                    </Button>

                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                        className={locations.pathname === "/profit-n-loss" ? 'highlight-button' : ''} onClick={() => navigate("/profit-n-loss")}
                    >
                        <MdOutlineStackedLineChart /> <Text fontSize="11px">Profit & Loss</Text>
                    </Button>
                </Flex>

                <Flex flexDirection="column" mt={2}>
                    <Text fontSize="12px" color="gray.400">Portfolio Management</Text>
                    <Button variant="ghost" height={8} color='white'_hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                        className={locations.pathname === "/order" ? 'highlight-button' : ''} onClick={() => navigate("/order")}
                    >
                        <MdFeaturedPlayList /> <Text fontSize="11px">Orders</Text>
                    </Button>
                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                        className={locations.pathname === "/wallet" ? 'highlight-button' : ''} onClick={() => navigate("/wallet")}
                    >
                        <FaWallet /> <Text fontSize="11px">Wallets</Text>
                    </Button>
                </Flex>

                <Flex flexDirection="column" mt={2}>
                    <Text fontSize="12px" color="gray.400">Profile</Text>
                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === "/referral" ? 'highlight-button' : ''} onClick={() => navigate("/referral")}
                    >
                        <FaHandshake /> <Text fontSize="11px">Referrals</Text>
                    </Button>
                </Flex>
                    
                {
                    cookies.loginCookie?.isAdministrator === true &&
                    <Flex flexDirection="column" mt={2}>
                        <Text fontSize="12px" color="gray.400">Settings</Text>
                        <Button variant="ghost" height={8} color='white'_hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                            className={locations.pathname === "/my-account" ? 'highlight-button' : ''} onClick={() => navigate("/my-account")}
                        >
                            <MdAccountBox /> <Text fontSize="11px">My Account</Text>
                        </Button>
                        <Button variant="ghost" height={8} color='white'_hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2} 
                            className={locations.pathname === "/accounts" ? 'highlight-button' : ''} onClick={() => navigate("/accounts")}
                        >
                            <FaUser /> <Text fontSize="11px">Accounts</Text>
                        </Button>
                        <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === "/wallet-trackings" ? 'highlight-button' : ''} onClick={() => navigate("/wallet-trackings")}
                        >
                            <PiEye /> <Text fontSize="11px">Wallet Trackings</Text>
                        </Button>
                        <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                            className={locations.pathname === "/system-configs" ? 'highlight-button' : ''} onClick={() => navigate("/system-configs")}
                        >
                            <FaCog /> <Text fontSize="11px">System Configs</Text>
                        </Button>
                    </Flex>
                }

                <Flex flexDirection="column" mt={2}>
                    <Text fontSize="12px" color="gray.400">Resources</Text>
                    <Button variant="ghost" height={8} color='white' alignItems="center" _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}>
                        <MdSmartDisplay /> <Text fontSize="11px">How to use</Text>
                    </Button>
                    <Button variant="ghost" height={8} color='white' _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}>
                        <ImRoad /> <Text fontSize="11px" color="white">Roadmap & Updates</Text>
                    </Button>
                </Flex>

                <Flex flexDirection="column" mt={2}>
                    <Text fontSize="12px" color="gray.400">Connect with us</Text>
                    <Flex flexDirection="row">
                        <IconButton variant="ghost" _hover="transparent" colorScheme="whiteAlpha" icon={<FaDiscord />} />
                        <IconButton variant="ghost" _hover="transparent" colorScheme="whiteAlpha" icon={<BsTwitterX />} />
                        <IconButton variant="ghost" _hover="transparent" colorScheme="whiteAlpha" icon={<FaTelegram />} />
                    </Flex>
                </Flex> */}

                <Button variant="ghost" height={8} colorScheme="red" mt={{ base: 8, md: 32, lg: 32 }} alignItems="center" 
                    _hover={{ opacity: 0.7 }} _active="transparent" justifyContent="flex-start" gap={2}
                    onClick={handleLogout}
                >
                    <FaSignOutAlt /> <Text fontSize="11px">Sign out</Text>
                </Button>
            </Flex>
        </Flex>
    )
}

export default LeftPanel;